<template>
    <button
        type="submit"
        @click="openModal()"
        :disabled="disabled"
        :title="confirmText"
        :class="
            disabled
                ? 'text-gray-700 bg-gray-100 cursor-default'
                : 'cursor-pointer text-indigo-700 bg-indigo-100 hover:bg-indigo-200'
        "
        class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
        <slot name="icon"></slot>

        <Modal :show="showModal" @close="showModal = false">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
                {{ title }}
            </h3>
            <slot></slot>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <AppButton element="button" @click="submit()" class="sm:ml-3" :desired-action="confirmButtonType">
                    {{ confirmMessage }}
                </AppButton>
                <AppButton element="button" @click="dismiss()">
                    {{ $t('messages.cancel') }}
                </AppButton>
            </div>
        </Modal>
    </button>
</template>
<script>
import Modal from '@/components/Modal.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'InertiaSquareConfirmActionButton',
    emits: ['finished'],
    components: {
        Modal,
        AppButton,
    },
    props: {
        href: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        danger: {
            type: Boolean,
            required: false,
            default: false,
        },
        method: {
            type: String,
            required: false,
            default: 'post',
        },
        confirm: {
            type: Boolean,
            default: true,
        },
        confirmText: {
            type: String,
        },
    },
    methods: {
        submit() {
            this.form.post(this.href, {
                preserveScroll: true,
                onSuccess: () => {
                    this.dismiss();
                },
            });
        },
        openModal() {
            if (!this.disabled) {
                this.showModal = true;
            }
        },
        dismiss() {
            this.showModal = false;
            this.$emit('finished');
        },
    },
    data() {
        return {
            showModal: false,
            confirmMessage: this.confirmText ? this.confirmText : this.$t('messages.confirm'),
            form: this.$inertia.form({
                _method: this.method,
            }),
        };
    },
    computed: {
        confirmButtonType() {
            if (this.danger) {
                return 'danger';
            }

            return true;
        },
    },
};
</script>
